/* Presentation only: existing text, images and native purchase controls remain intact. */
document.addEventListener('DOMContentLoaded', () => {
  // The redesign offers only one-time purchase and subscription on ACEMg: the
  // Starter Kit is withdrawn. sb-product-editorial.css hides it before this runs.
  document.querySelectorAll('[data-starter-kit-block]').forEach(el => el.remove());
  const purchase = document.querySelector('.sb-product__form,.soundbites-product-wrapper');
  if (purchase && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => document.body.toggleAttribute('data-purchase-in-view', entry.isIntersecting)).observe(purchase);
  }
  const story = document.querySelector('.sb-kit__story .product-description');
  if (story && story.children.length > 2) {
    const before = story.textContent;
    const intro = document.createElement('div'); intro.className = 'sb-editorial-intro';
    const details = document.createElement('div'); details.className = 'sb-editorial-details';
    let paragraphs = 0;
    [...story.childNodes].forEach(node => {
      (paragraphs < 2 ? intro : details).append(node);
      if (node.nodeType === 1) paragraphs++;
    });
    story.classList.add('sb-editorial-grid'); story.append(intro, details);
    console.assert(story.textContent === before, 'Product text must be preserved');
  }
});
